import axios from 'axios';

// GET /admin/candidates -> [{ id (candidateId), email, name, sponsor, status, ... }].
// Used to populate the reassign picker with candidates of the token's sponsor. The backend
// re-validates same-sponsor / no-active-assignment authoritatively, so this list is a
// convenience filter only.
export async function getAdminCandidates() {
  try {
    const res = await axios.get('/admin/candidates');
    return (res.data && res.data.candidates) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
